// Hace cuánto se leyó un dato, en palabras.
//
// La BASE es el instante en que el dato llegó (`dataUpdatedAt` de la consulta),
// nunca `Date.now()` medido dentro del render: dos renders del mismo dato tienen
// que decir lo mismo, y una edad recalculada al vuelo convierte cada repintado
// en un número distinto sin que nada haya pasado.

const MINUTE = 60_000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

/**
 * "hace unos segundos" / "hace N min" / "hace N h" / "hace N d".
 *
 * Los tramos son los que una persona dice en voz alta: por debajo del minuto no
 * se cuentan segundos, porque el número exacto no cambia ninguna decisión. Una
 * base futura (relojes desfasados) se lee como recién leída, en vez de imprimir
 * un negativo.
 */
export function relativeAgeEs(at: number, now: number): string {
  const ms = Math.max(0, now - at)
  if (ms < MINUTE) return 'hace unos segundos'
  if (ms < HOUR) return `hace ${Math.floor(ms / MINUTE)} min`
  if (ms < DAY) return `hace ${Math.floor(ms / HOUR)} h`
  return `hace ${Math.floor(ms / DAY)} d`
}
